import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import * as _ from 'lodash';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Footer, PrimeTemplate } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';

declare var $: any;

@Component({
    selector: 'activity-typologyPop',
    templateUrl: 'activity-typologyPopup.component.html',
    standalone: true,
    imports: [DialogModule, PrimeTemplate, TooltipModule, DropdownModule, FormsModule, Footer, TranslateModule]
})
export class ActivityTypologyPopUpComponent implements OnInit {
  private translate = inject(TranslateService);


  activities: any[];
  periodOptions: any;

  state: string;
  status: string;

  typterm: string;
  display: boolean = false;
  data: string;

  @Input() idx: number;
  @Input() params: any;

  @Output() closepopup: EventEmitter<boolean> = new EventEmitter();
  @Output() saveData: EventEmitter<{ params: any, indx: number }> = new EventEmitter();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.periodOptions = [
      { name: this.translate.instant('widgets.party-activities.Week'), value: 'Week' },
      { name: this.translate.instant('widgets.party-activities.Day'), value: 'Day' },
      { name: this.translate.instant('widgets.party-activities.Month'), value: 'Month' }
    ];
  }

  ngOnInit(): void {
    this.state = "All";
    this.data = "Week";

    if (this.params) {
      if (this.params.state)
        this.state = this.params.state;

      if (this.params.date)
        this.data = this.params.date;
    }

    this.display = true;
  }

  getData(name: string) {
    return 'widgets.party-activities.' + name;
  }

  getState(state: string) {
    return 'widgets.party-activities.' + state;
  }

  cancel() {
    this.closepopup.next(true);
  }

  clearDefault() {
    this.state = "All";
    this.data = "Week";
  }

  stateChange(state: string) {
    this.state = state;
  }

  confirm() {
    let parms = {
      state: this.state,
      date: this.data
    }

    this.saveData.next({ params: parms, indx: this.idx });
    this.closepopup.next(true);
    this.display = false;
  }
}
